import dash_api from '../../../support/dash_api';
import { ReduxAsyncAction } from '../../../support/utils';

const V1 = '/v1';
const USAGE_PATH = '/usage';
const MAU_PATH = '/mau';

const FetchMauLimit = new ReduxAsyncAction('FETCH_MAU_LIMIT');
FetchMauLimit.registerRequest(async () => {
  const URI = `${V1}${USAGE_PATH}${MAU_PATH}/count-data`;
  try {
    const countData = await dash_api.get(URI);
    return countData?.data?.limit;
  } catch (e) {
    throw e;
  }
});

export const FETCH_MAU_LIMIT = FetchMauLimit.constants;
export const fetchMauLimit = FetchMauLimit.request;

const FetchMauOverageCost = new ReduxAsyncAction('FETCH_MAU_OVERAGE_COST');
FetchMauOverageCost.registerRequest(async () => {
  const URI = `${V1}${USAGE_PATH}${MAU_PATH}/overage-cost`;
  try {
    const overageCost = await dash_api.get(URI);
    return overageCost;
  } catch (e) {
    throw e;
  }
});

export const FETCH_MAU_OVERAGE_COST = FetchMauOverageCost.constants;
export const fetchMauOverageCost = FetchMauOverageCost.request;

const FetchMauCountData = new ReduxAsyncAction('FETCH_MAU_COUNT_DATA');
FetchMauCountData.registerRequest(async () => {
  const URI = `${V1}${USAGE_PATH}${MAU_PATH}/count-data`;
  try {
    const countData = await dash_api.get(URI);
    return countData?.data;
  } catch (e) {
    throw e;
  }
});

export const FETCH_MAU_COUNT_DATA = FetchMauCountData.constants;
export const fetchMauCountData = FetchMauCountData.request;
